import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ParticleField from "./ParticleField";
import AnnouncementBar from "./AnnouncementBar";

export default function Layout() {
  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <ParticleField />
      <Navbar />
      <AnnouncementBar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
